import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SurveyRespondentConflictType } from '../../../enums/survey-respondent-conflict-type';

@Component({
  selector: 'app-respondent-already-exists-modal',
  templateUrl: './respondent-already-exists-modal.component.html',
  standalone: false,
})
export class RespondentAlreadyExistsModalComponent {
  constructor(
    public dialogRef: MatDialogRef<RespondentAlreadyExistsModalComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      fieldValue: string;
      conflictType: SurveyRespondentConflictType;
    },
  ) {}

  close() {
    this.dialogRef.close(false);
  }

  continue() {
    this.dialogRef.close(true);
  }
}
